import { isSafari } from "common/utils/browser";
import { AILoading } from "./AILoading";

const LOADER_GIF = "https://jiffy.imgix.net/gen/ai-loader.gif?ixlib=rb-0.3.5&auto=format";
const SPARKLE_GIF = "https://jiffy.imgix.net/gen/spangle-sparkle.gif?ixlib=rb-0.3.5&auto=format";

export type LoadingBoxProps = {
  startTime: number | undefined;
  estimatedDuration: number;
  isDone?: boolean;
  imagePreview?: { url?: string | undefined; file?: File | undefined } | undefined;
};

export function LoadingBox(props: LoadingBoxProps) {
  const { startTime, estimatedDuration, imagePreview, isDone = false } = props;
  return (
    <div
      className="bg-background w-[350px] rounded-xl border border-gray-200 p-4 shadow-lg md:w-fit"
      data-testid="loading-box-container"
    >
      <h2 className="col-span-2 mb-2 text-center text-lg font-bold text-gray-900">
        Making your image PrintPerfect™
      </h2>

      <div className="grid grid-cols-[70px_minmax(0,1fr)] items-stretch gap-x-3 md:grid-cols-[144px_minmax(300px,1fr)] md:gap-x-6 md:gap-y-4">
        <div className="row-span-2 flex h-full items-center justify-center md:row-span-1">
          {imagePreview?.url ? (
            <div className="relative size-16 max-h-full max-w-full overflow-hidden rounded-lg object-contain lg:size-auto">
              <div className="z-5 absolute left-0 top-0 h-full w-full">
                <img
                  src={SPARKLE_GIF}
                  alt="Sparkle"
                  className="size-full opacity-40"
                  data-testid="loading-sparkle-overlay"
                />
              </div>

              <img
                src={imagePreview.url}
                alt="Preview"
                className="size-full max-h-full max-w-full object-contain"
                data-testid="loading-preview-image"
              />
            </div>
          ) : (
            <div className="flex h-16 w-16 items-center justify-center rounded-sm bg-gray-200 p-1 text-sm uppercase text-gray-500 lg:h-20 lg:w-20">
              {imagePreview?.file?.type?.split("/")?.pop()}
            </div>
          )}
        </div>

        <div>
          <div className="hidden items-center justify-center md:flex">
            {isSafari() ? (
              <div className="min-h-22 flex flex-1 items-center justify-center">
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-black border-t-transparent" />
              </div>
            ) : (
              <img
                src={LOADER_GIF}
                alt="Loader"
                className="w-22 h-22 size-full object-contain"
                data-testid="loading-spinner-gif"
              />
            )}
          </div>

          <AILoading startTime={startTime} estimatedDuration={estimatedDuration} isDone={isDone} />
        </div>
      </div>
    </div>
  );
}
